import('../vue-shared').then(({default: vue}) => {
  $(() => {
    const mountPoint = document.getElementById('hardware-key-auth');
    if (!mountPoint) {
      return;
    }

    import('./HardwareKeyAuth.vue').then(({default: component}) => {
      new vue({
        render: (h) => h(component),
        el: mountPoint,
      }).$mount();
    });
  });
});
